/* ELV Storefront. Original behavior. Copyright ELV Motors, Inc. */
(function () {
  var moneyFormat = (window.ELV && window.ELV.moneyFormat) || "${{amount}}";

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var value = (Number(cents) / 100).toFixed(2);
    var whole = (Number(cents) / 100).toFixed(0);
    var commas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return String(moneyFormat)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace(".", ","))
      .replace(/\{\{\s*amount\s*\}\}/, commas);
  }

  function lock(on) { document.body.classList.toggle("elv-lock", on); }

  function openName(name) {
    qsa("[data-elv-drawer]").forEach(function (el) { el.hidden = el.getAttribute("data-elv-drawer") !== name; });
    lock(true);
    var panel = qs('[data-elv-drawer="' + name + '"] input, [data-elv-drawer="' + name + '"] button');
    if (panel) panel.focus();
  }

  function closeDrawers() {
    qsa("[data-elv-drawer]").forEach(function (el) { el.hidden = true; });
    lock(false);
  }

  document.addEventListener("click", function (event) {
    var opener = event.target.closest("[data-elv-open]");
    if (opener) {
      event.preventDefault();
      openName(opener.getAttribute("data-elv-open"));
      return;
    }
    if (event.target.closest("[data-elv-close]")) {
      event.preventDefault();
      closeDrawers();
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeDrawers();
  });

  function setCount(count) {
    var n = String(count);
    qsa("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.setAttribute("data-empty", n === "0" ? "true" : "false");
    });
  }

  function esc(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (char) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[char];
    });
  }

  function renderCart(cart) {
    if (!cart.item_count) {
      return '<p class="elv-cart__empty">Your cart is empty.</p><a class="elv-btn" href="/collections/all">Continue shopping</a>';
    }
    var lines = cart.items.map(function (item, index) {
      var meta = item.variant_title && item.variant_title !== "Default Title" ? '<p class="elv-line__meta">' + esc(item.variant_title) + "</p>" : "";
      var was = item.original_line_price > item.final_line_price ? "<s>" + formatMoney(item.original_line_price) + "</s>" : "";
      var img = item.image ? '<img src="' + esc(item.image) + '" alt="">' : "";
      return '<li class="elv-line"><a class="elv-line__media" href="' + esc(item.url) + '">' + img + '</a><div class="elv-line__info"><a class="elv-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + "</a>" + meta +
        '<div class="elv-qty" data-line="' + (index + 1) + '"><button type="button" data-elv-qty="decrease" aria-label="Decrease quantity">−</button><input type="number" min="0" value="' + item.quantity + '" data-elv-qty-input aria-label="Quantity"><button type="button" data-elv-qty="increase" aria-label="Increase quantity">+</button></div><button type="button" class="elv-line__remove" data-elv-qty="remove">Remove</button></div><div class="elv-line__price">' + was + "<span>" + formatMoney(item.final_line_price) + "</span></div></li>";
    }).join("");
    return '<div class="elv-cart__body"><ul class="elv-lines">' + lines + '</ul></div><div class="elv-cart__foot"><p class="elv-cart__sub"><span>Subtotal</span> <span data-cart-subtotal>' + formatMoney(cart.total_price) + '</span></p><p class="elv-cart__note">Taxes and shipping calculated at checkout.</p><a class="elv-btn" href="/checkout">Checkout</a></div>';
  }

  function updateTotals(cart) {
    qsa("[data-cart-subtotal]").forEach(function (el) { el.textContent = formatMoney(cart.total_price); });
  }

  async function refreshCart() {
    var holder = qs("[data-cart-section]");
    var id = holder ? holder.getAttribute("data-cart-section") : "";
    if (id) {
      try {
        var root = (window.ELV && window.ELV.routes.root) || "/";
        var response = await fetch(root + (root.indexOf("?") === -1 ? "?" : "&") + "sections=" + encodeURIComponent(id), { headers: { Accept: "application/json" } });
        var data = await response.json();
        var html = data[id];
        if (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var next = doc.querySelector("[data-cart-region]");
          var current = qs("[data-cart-region]");
          if (next && current) {
            current.innerHTML = next.innerHTML;
            var count = doc.querySelector("[data-cart-count]");
            if (count) setCount(count.textContent.trim());
            var sub = doc.querySelector("[data-cart-subtotal]");
            if (sub) qsa("[data-cart-subtotal]").forEach(function (el) { el.textContent = sub.textContent.trim(); });
            if (window.elvShopcodes) window.elvShopcodes.rewriteLinks(document);
            document.dispatchEvent(new CustomEvent("elv:cart-refreshed"));
            return;
          }
        }
      } catch (error) {}
    }
    var cart = await fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
    setCount(cart.item_count);
    updateTotals(cart);
    var region = qs("[data-cart-region]");
    if (region) region.innerHTML = renderCart(cart);
    if (window.elvShopcodes) window.elvShopcodes.rewriteLinks(document);
    document.dispatchEvent(new CustomEvent("elv:cart-refreshed"));
  }

  function showFormError(form, message) {
    var box = form.querySelector("[data-form-error]");
    if (!box) return;
    box.hidden = !message;
    box.textContent = message || "";
  }

  document.addEventListener("submit", function (event) {
    var form = event.target.closest("form[data-elv-product-form], form.elv-product-form");
    if (!form) return;
    if (event.submitter && event.submitter.name !== "add") return;
    event.preventDefault();
    var button = form.querySelector("[name='add']");
    if (button) button.disabled = true;
    showFormError(form, "");
    fetch((window.ELV && window.ELV.routes.cartAdd) || "/cart/add", {
      method: "POST",
      body: new FormData(form),
      headers: { Accept: "application/json" }
    }).then(function (response) {
      if (!response.ok) return response.json().then(function (data) { throw new Error(data.description || data.message || "Could not add to cart"); });
      return response.json();
    }).then(function () {
      return refreshCart();
    }).then(function () {
      openName("cart");
    }).catch(function (error) {
      showFormError(form, error.message);
    }).finally(function () {
      if (button && !button.hasAttribute("data-keep-disabled")) button.disabled = false;
    });
  });

  function changeLine(line, quantity) {
    return fetch((window.ELV && window.ELV.routes.cartChange) || "/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function (response) { return response.json(); });
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-elv-qty]");
    if (!button) return;
    var row = button.closest("[data-line]");
    if (!row) return;
    var input = row.querySelector("[data-elv-qty-input]");
    var current = input ? Number(input.value) || 0 : 1;
    var action = button.getAttribute("data-elv-qty");
    var next = current;
    if (action === "increase") next = current + 1;
    if (action === "decrease") next = Math.max(0, current - 1);
    if (action === "remove") next = 0;
    var onPage = button.closest("[data-cart-page]");
    changeLine(Number(row.getAttribute("data-line")), next).then(function () {
      if (onPage) window.location.reload();
      else return refreshCart();
    });
  });

  document.addEventListener("change", function (event) {
    var input = event.target.closest("[data-elv-qty-input]");
    if (!input) return;
    var row = input.closest("[data-line]");
    if (!row) return;
    var onPage = input.closest("[data-cart-page]");
    changeLine(Number(row.getAttribute("data-line")), Math.max(0, Number(input.value) || 0)).then(function () {
      if (onPage) window.location.reload();
      else return refreshCart();
    });
  });

  function selectedOptions(form) {
    return qsa("[data-option-input]", form).filter(function (input) {
      return input.matches("select") || input.checked;
    }).sort(function (a, b) {
      return Number(a.getAttribute("data-option-position")) - Number(b.getAttribute("data-option-position"));
    }).map(function (input) { return input.value; });
  }

  function findVariant(variants, options) {
    return variants.find(function (variant) {
      return variant.options.every(function (value, index) { return value === options[index]; });
    });
  }

  function payUrl(handle, variantId, qty) {
    return "https://order.elvmotors.com/suborder?handle=" + encodeURIComponent(handle) +
      "&variant=" + encodeURIComponent(variantId) +
      "&qty=" + encodeURIComponent(String(Math.max(1, qty || 1)));
  }

  function applyVariant(form, variant) {
    var idInput = form.querySelector("[name='id']");
    if (idInput && variant) idInput.value = variant.id;
    var price = form.closest("[data-elv-product]") || form.parentElement;
    var now = qs("[data-elv-price]", price);
    var was = qs("[data-elv-compare]", price);
    if (now && variant) now.textContent = formatMoney(variant.price);
    if (was) {
      if (variant && variant.compare_at_price > variant.price) {
        was.hidden = false;
        was.textContent = formatMoney(variant.compare_at_price);
      } else {
        was.hidden = true;
      }
    }
    var sku = qs("[data-elv-sku]", price);
    if (sku) sku.textContent = variant && variant.sku ? variant.sku : "";
    var stock = qs("[data-elv-stock]", price);
    if (stock && variant) {
      if (!variant.available) {
        stock.textContent = "Sold out";
        stock.setAttribute("data-level", "out");
      } else if (variant.inventory_management && variant.inventory_quantity <= 5) {
        stock.textContent = "Only " + variant.inventory_quantity + " left";
        stock.setAttribute("data-level", "low");
      } else {
        stock.textContent = "In stock";
        stock.setAttribute("data-level", "in");
      }
    }
    var add = form.querySelector("[name='add']");
    if (add) {
      add.disabled = !(variant && variant.available);
      add.textContent = variant && variant.available ? "Add to cart" : "Sold out";
      if (!variant || !variant.available) add.setAttribute("data-keep-disabled", "true");
      else add.removeAttribute("data-keep-disabled");
    }
    var img = qs(".elv-main-image");
    if (img && variant && variant.featured_image && variant.featured_image.src) {
      img.src = variant.featured_image.src;
      img.removeAttribute("srcset");
    }
    var pay = document.getElementById("pay-at-elv-link");
    var productRoot = form.closest("[data-elv-product]");
    if (pay && variant && productRoot) {
      var qtyInput = form.querySelector("[name='quantity']");
      pay.href = payUrl(productRoot.getAttribute("data-handle"), variant.id, qtyInput ? Number(qtyInput.value) : 1);
    }
    if (variant && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url);
    }
  }

  qsa("[data-elv-product]").forEach(function (root) {
    var form = qs("[data-elv-product-form]", root);
    var data = qs("[data-elv-variants]", root);
    if (!form || !data) return;
    var variants = [];
    try { variants = JSON.parse(data.textContent); } catch (error) { variants = []; }
    function sync() {
      if (!qsa("[data-option-input]", form).length) return;
      applyVariant(form, findVariant(variants, selectedOptions(form)));
    }
    form.addEventListener("change", function (event) {
      if (event.target.matches("[data-option-input], [name='quantity']")) sync();
    });
  });

  qsa("[data-elv-thumb]").forEach(function (button) {
    button.addEventListener("click", function () {
      var img = qs(".elv-main-image");
      if (!img) return;
      img.src = button.getAttribute("data-src");
      img.removeAttribute("srcset");
      qsa("[data-elv-thumb]").forEach(function (el) { el.removeAttribute("aria-current"); });
      button.setAttribute("aria-current", "true");
    });
  });

  var searchInput = qs("[data-elv-search-input]");
  var searchResults = qs("[data-elv-search-results]");
  var searchTimer;
  if (searchInput && searchResults) {
    searchInput.addEventListener("input", function () {
      clearTimeout(searchTimer);
      var query = searchInput.value.trim();
      if (query.length < 2) {
        searchResults.innerHTML = "";
        return;
      }
      searchTimer = setTimeout(function () {
        var base = (window.ELV && window.ELV.routes.predictive) || "/search/suggest";
        var url = base + (base.indexOf("?") === -1 ? "?" : "&") + "q=" + encodeURIComponent(query) + "&resources[type]=product,collection,page,article&resources[limit]=6&resources[options][unavailable_products]=last";
        fetch(url, { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(function (data) {
          var products = (((data.resources || {}).results || {}).products) || [];
          if (!products.length) {
            searchResults.innerHTML = "<p>No matching products.</p>";
            return;
          }
          searchResults.innerHTML = "<ul class='elv-suggest'>" + products.map(function (product) {
            var href = product.url;
            if (document.documentElement.classList.contains("elv-store-mode")) {
              href += (href.indexOf("?") === -1 ? "?" : "&") + "utm_source=shopcodes";
            }
            var image = product.image ? "<img src='" + esc(product.image) + "' alt=''>" : "<span></span>";
            return "<li><a href='" + esc(href) + "'>" + image + "<span>" + esc(product.title) + "</span><strong>" + (typeof product.price === "number" || /^\d+$/.test(String(product.price)) ? formatMoney(product.price) : esc(product.price)) + "</strong></a></li>";
          }).join("") + "</ul>";
        }).catch(function () {
          searchResults.innerHTML = "";
        });
      }, 180);
    });
  }

  qsa("[data-slideshow]").forEach(function (root) {
    var slides = qsa("[data-slide]", root);
    if (slides.length < 2) return;
    var index = 0;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) { slide.hidden = i !== index; });
    }
    show(0);
    root.addEventListener("click", function (event) {
      var button = event.target.closest("[data-slide-dir]");
      if (!button) return;
      show(index + Number(button.getAttribute("data-slide-dir")));
    });
    var delay = Number(root.getAttribute("data-autoplay") || 0);
    if (delay && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setInterval(function () { show(index + 1); }, delay);
    }
  });

  var filterToggle = qs("[data-elv-filters]");
  if (filterToggle) {
    filterToggle.addEventListener("click", function () {
      var panel = qs(".elv-filters");
      if (panel) panel.classList.toggle("is-open");
    });
  }

  if (document.body.getAttribute("data-product-handle")) {
    try {
      var handle = document.body.getAttribute("data-product-handle");
      var seen = JSON.parse(localStorage.getItem("elv-recent") || "[]").filter(function (item) { return item !== handle; });
      seen.unshift(handle);
      localStorage.setItem("elv-recent", JSON.stringify(seen.slice(0, 8)));
    } catch (error) {}
  }

  var recent = qs("[data-elv-recent]");
  if (recent) {
    var current = document.body.getAttribute("data-product-handle") || "";
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem("elv-recent") || "[]"); } catch (error) { handles = []; }
    handles = handles.filter(function (item) { return item && item !== current; }).slice(0, 4);
    if (!handles.length) {
      recent.hidden = true;
    } else {
      Promise.all(handles.map(function (handle) {
        return fetch("/products/" + handle + ".js", { headers: { Accept: "application/json" } }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var cards = products.filter(Boolean).map(function (product) {
          var href = product.url;
          if (document.documentElement.classList.contains("elv-store-mode")) href += "?utm_source=shopcodes";
          var image = product.featured_image ? "<img class='elv-card__img' src='" + esc(product.featured_image) + "' alt=''>" : "";
          return "<article class='elv-card'><a class='elv-card__media' href='" + esc(href) + "'>" + image + "</a><div class='elv-card__body'><h3 class='elv-card__title'><a href='" + esc(href) + "'>" + esc(product.title) + "</a></h3><span class='elv-price'>" + formatMoney(product.price) + "</span></div></article>";
        }).join("");
        var grid = recent.querySelector("[data-elv-recent-grid]");
        if (grid) grid.innerHTML = cards;
        recent.hidden = !cards;
      });
    }
  }

  var related = qs("[data-elv-related]");
  if (related && related.getAttribute("data-url") && !related.querySelector(".elv-card")) {
    fetch(related.getAttribute("data-url"))
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var next = doc.querySelector("[data-elv-related]");
        if (next && next.querySelector(".elv-card")) related.innerHTML = next.innerHTML;
        else related.hidden = true;
        if (window.elvShopcodes) window.elvShopcodes.rewriteLinks(related);
      })
      .catch(function () { related.hidden = true; });
  }
})();
